<section id="company" data-home-company class="bg-white">
  <div class="mx-auto max-w-7xl px-4">
    <div
      class="grid items-center gap-7 rounded-3xl bg-emerald-50/50 p-5 md:grid-cols-2 md:gap-10 md:p-8"
    >
      <div class="min-w-0">
        <p
          class="mb-3 text-xs font-semibold uppercase tracking-widest text-emerald-700"
        >
          {{ content.eyebrow }}
        </p>
        <h2
          class="mb-4 text-2xl font-bold leading-tight text-slate-900 md:text-3xl"
        >
          {{ content.title }}
        </h2>
        <p class="mb-3 text-base leading-relaxed text-slate-700">
          {{ content.description }}
        </p>
        <p class="m-0 text-sm leading-relaxed text-slate-600">
          {{ content.detail }}
        </p>
      </div>
      <div
        class="aspect-[4/3] overflow-hidden rounded-2xl bg-emerald-100 shadow-sm"
      >
        <img
          appImgFallback
          [src]="content.imageSrc"
          [alt]="content.imageAlt"
          loading="lazy"
          class="h-full w-full object-cover"
        />
      </div>
    </div>
    <div class="mt-5 grid gap-3 md:grid-cols-3 md:gap-5">
      @for (highlight of content.highlights; track $index) {
        <article
          class="flex gap-4 rounded-2xl border border-slate-200 bg-white p-5"
        >
          <span
            class="flex h-10 w-10 flex-none items-center justify-center rounded-xl bg-emerald-50 text-sm font-bold text-emerald-700"
            >0{{ $index + 1 }}</span
          >
          <div class="min-w-0">
            <h3 class="mb-2 text-base font-semibold text-slate-900">
              {{ highlight.title }}
            </h3>
            <p class="m-0 text-sm leading-relaxed text-slate-600">
              {{ highlight.description }}
            </p>
          </div>
        </article>
      }
    </div>
  </div>
</section>
